export const rectangleRevealOptions = {
  duration: 0.8,
  ease: 'Quad.easeInOut',
  from: 'center',
  clearProps: '', // clipPath, webkitClipPath
  type: 'in',
};

export const rectangleHideOptions = {
  duration: 0.8,
  ease: 'Power2.easeOut',
  to: 'bottom',
  type: 'out',
};
